<template>
  <div class="row" v-if="permissao">
    <div class="col-xs-12">
      <div class="row">
        <div class="col-md-2">
          <label>UF</label>
          <select :disabled="loading" class="form-control" v-model="ufSelecionada" @change="onChangeFiltro()">
            <option :value="null">- Selecione -</option>
            <option v-for="uf in ufs" :value='uf.id'>{{ uf.nome }}</option>
          </select>
        </div>
        <div class="col-md-2">
          <label>Ano</label>
          <select :disabled="loading" class="form-control" v-model="anoSelecionado" @change="onChangeFiltro()">
            <option :value="null">- Selecione -</option>
            <option v-for="i in anos">{{ i.ano }}</option>
          </select>
        </div>
        <div class="col-md-2">
          <label>Mês</label>
          <select :disabled="loading || anoSelecionado == null" class="form-control" v-model="mesSelecionado" @change="onChangeFiltro()">
            <option :value="null">- Selecione -</option>
            <option v-for="mes in meses" :value="mes">{{ mes.nome }}</option>
          </select>
        </div>
        <div class="col-md-4">
          <label>Contrato</label>
          <select :disabled="loading" class="form-control" align="center" v-model="contratoSelecionado" @change="onChangeFiltro()">
            <option :value="null">- Selecione -</option>
            <option v-for="i in tipo_imovel_servicos" :value='i'>{{ i.nome }}</option>
          </select>
        </div>
        <div class="col-md-2">
          <button class="btn btn-default" variant="primary" v-on:click="limparFiltro()" style="margin-top: 24px"> Limpar Filtro
          </button>
        </div>
      </div>
      <br>
      <div class="box box-default">
        <div class="box-header with-header">
          <h3 align="center">Fechamento Extracontratual</h3>
        </div>
        <!-- /.box-header -->
        <div v-if="loading">
          <h4 style="width: 100%; text-align: center;"><b>Carregando Dados. <p> Aguarde um momento...</p></b></h4>
          <HalfCircleSpinner :animation-duration="2000" :size="60" :color="'#3c8dbc'" style="margin: 0 auto; float: none;" />
        </div>
        <div class="box-body table-responsive no-padding" v-else-if="fechamentos != ''">
          <table class="table table-hover">
            <tbody>
              <tr>
                <th class="text-center">ID</th>
                <th class="text-center">Estado</th>
                <th class="text-center">Contrato</th>
                <th class="text-center">Mês</th>
                <th class="text-center">Ano</th>
                <th class="text-center">Serviços</th>
                <th class="text-center">Ação</th>
              </tr>
              <tr v-for="(fechamento, index) in records" :key="fechamento.id" v-bind:key="fechamento.id" v-if="index + 1 >= startIndex && index + 1 <= endIndex && !loading">
                <td class="text-center"><a title="Detalhes fechamento" href='javascript:void(0)' v-on:click="detalhesFechamentoExtra(fechamento.id)">{{ fechamento.id }}</a></td>
                <td class="text-center">{{ fechamento.uf }}</td>
                <td class="text-center">{{ fechamento.tipo_imovel_servico }}</td>
                <td class="text-center">{{ fechamento.nome }}</td>
                <td class="text-center">{{ fechamento.ano_de_referencia }}</td>
                <td class="text-center">
                  <span v-if="fechamento.servicos && fechamento.servicos.length > 0">
                    <span v-for="servico in fechamento.servicos" :key="servico.id" class="badge-servico">{{ servico.descricao }}</span>
                  </span>
                  <span v-else>-</span>
                </td>
                <td class="text-center"><a title="Excluir" href='javascript:void(0)' @click="excluirFechamentoExtra(fechamento.id)"><b-icon icon="trash-fill" font-scale="1.2" aria-hidden="true"></b-icon></a></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          <h4 class="form-inline" v-if="this.filtro == null"> Você não possui fechamento preenchido. </h4>
          <h4 class="form-inline" v-else> Você não possui fechamento extracontratual filtrado. </h4>
        </div>
        <div v-if="!loading" align="center">
          <pagination :records="recordsLength" v-model="page" :per-page="perPage" @paginate="getPage"></pagination>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Pagination from 'vue-pagination-2'
import Swal from 'sweetalert2'
import { HalfCircleSpinner } from 'epic-spinners'
// import exportarFechamentoExtra from './ExportarFechamentoExtra.vue'

export default {
  data() {
    return {
      env: process.env,
      page: 1,
      startIndex: 1,
      endIndex: 15,
      perPage: 15,
      records: [],
      recordsLength: 0,
      fechamentos: null,
      ufs: [],
      tipo_imovel_servicos: [],
      anos: [],
      meses: [],
      gruposPermitidos: ['oi', 'admin'],
      permissao: true,
      ufSelecionada: null,
      contratoSelecionado: null,
      mesSelecionado: null,
      anoSelecionado: null,
      filtro: null,
      loading: false
    }
  },
  components: {
    // 'exportar-fechamento-extra': exportarFechamentoExtra
    Pagination,
    Swal,
    HalfCircleSpinner
  },
  mounted: function () {
    // Array com grupos do usuário
    let usuarioGrupo = this.$store.state.login.loginUsuario.grupo
    // msg(setPermissaoNegada) - função verificando se o usuário possui mais de um grupo(max 3)
    let msgGrupos = usuarioGrupo[0].nome
    if (usuarioGrupo[1]) {
      msgGrupos = usuarioGrupo[0].nome + ' ,' + usuarioGrupo[1].nome
      if (usuarioGrupo[2]) {
        msgGrupos = usuarioGrupo[0].nome + ' ,' + usuarioGrupo[1].nome + ' ,' + usuarioGrupo[2].nome
      }
    }
    // console.log(msgGrupos)
    // if (this.gruposPermitidos.indexOf(usuarioGrupo) === -1) {
    // if (this.usuarioGrupo.includes('admin') === true || this.usuarioGrupo.includes('oi') === true) {
    if (usuarioGrupo.find(permissao => permissao.nome === 'oi' || permissao.nome === 'admin' || permissao.nome === 'adminVTAL')) {
      this.getFechamentos()
      this.getPage(this.page)
      this.getUfsDoUsuario()
      this.getTipoImovelServico()
      this.getAno()
      this.getMes()
    } else {
      this.permissao = false
      this.$store.commit('setPermissaoNegada', { msg: `Seu grupo de usuáro [ ${msgGrupos} ] não permite acesso a esta área.`, status: false, show: true })
    }
  },
  methods: {
    detalhesFechamentoExtra: function (idFechamento) {
      this.$router.push(`/DetalhesFechamentoExtra/?id=${idFechamento}`)
    },
    getPage: function (page) {
      // we simulate an api call that fetch the records from a backend
      let vm = this
      let startIndex = vm.perPage * (page - 1) + 1
      let endIndex = startIndex + vm.perPage - 1
      vm.startIndex = startIndex
      vm.endIndex = endIndex
      if (vm.fechamentos !== null) {
        // for (let i = startIndex; i <= endIndex; i++) {
        vm.records = vm.fechamentos
        // }
      }
    },
    getFechamentos() {
      this.loading = true
      let parametros = {
        grupo: this.$store.state.login.loginUsuario.grupo,
        estado: this.$store.state.login.loginUsuario.estado,
        contrato: this.$store.state.login.loginUsuario.contrato,
        filtro: this.filtro
      }
      let vm = this
      this.$axios.post(`${this.env.FINANCEIRO.SLA}/getAllExtraContratual`, parametros, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      }).then(function (response) {
        if (response.status === 200 || response.status === 201) {
          vm.fechamentos = response.data
          vm.records = response.data
          vm.recordsLength = response.data.length
          vm.loading = false
        } else {
          vm.$store.commit('setAlert', { msg: response.data.erro, status: false, show: true })
        }
      })
    },
    getUfsDoUsuario() {
      this.ufs = this.$store.state.login.loginUsuario.estado
    },
    getTipoImovelServico() {
      let vm = this
      this.$axios.get(`${this.env.FINANCEIRO.SLA}/gettipoimovelservico`, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      })
        .then(function (response) {
          vm.tipo_imovel_servicos = response.data
        })
    },
    getAno() {
      let vm = this
      this.$axios.get(`${this.env.FINANCEIRO.SLA}/getano`, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      })
        .then(function (response) {
          vm.anos = response.data
        })
    },
    getMes() {
      let date = new Date()
      this.mes_atual = date.getMonth()
      let vm = this
      this.$axios.get(`${this.env.FINANCEIRO.SLA}/getmes`, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      }).then(function (response) {
        vm.meses = response.data
      })
    },
    excluirFechamentoExtra(id) {
      let vm = this
      Swal.fire({
        title: 'Tem certeza que deseja excluir?',
        // text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, excluir!'
      }).then((result) => {
        if (result.isConfirmed) {
          let payload = {
            usuario_id: this.$store.state.login.loginUsuario.usuario.id,
            fechamento_extra_id: id
          }
          this.$axios.post(`${this.env.FINANCEIRO.SLA}/excluirExtraContratual`, payload, {
            headers: {
              'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
            }
          }).then(function (response) {
            if (response.status === 200 || response.status === 201) {
              // vm.$store.commit('setAlert', {msg: response.data, status: true, show: true})
              Swal.fire(
                'Excluído!',
                response.data
              )
              setTimeout(() => {
                location.reload()
              }, 1500)
            } else {
              vm.$store.commit('setAlert', { msg: response.data.erro, status: false, show: true })
            }
          })
        }
      })
    },
    onChangeFiltro() {
      this.filtro = {
        ufSelecionada: this.ufSelecionada,
        contratoSelecionado: this.contratoSelecionado,
        mesSelecionado: this.mesSelecionado,
        anoSelecionado: this.anoSelecionado
      }

      this.page = 1
      this.getFechamentos()
    },
    limparFiltro() {
      this.filtro = null
      this.ufSelecionada = null
      this.contratoSelecionado = null
      this.mesSelecionado = null
      this.anoSelecionado = null

      this.page = 1
      this.getFechamentos()
    }
  }
}
</script>

<style scoped>
h2 {
  margin-bottom: .5em;
}

.fechamento {
  background-color: aqua;
}

.box-header {
  padding-bottom: 2.5em;
}

.badge-servico {
  display: inline-block;
  background-color: #3c8dbc;
  color: #fff;
  border-radius: 4px;
  padding: 2px 8px;
  margin: 2px 3px 2px 0;
  font-size: 0.8em;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// ExibirFechamentoExtra.vue?d45482c0